import { RestRequest } from "msw";

export function mockAuthCheck(req: RestRequest): boolean {
  if (!req.headers.get("idToken")) {
    return false;
  }
  return true;
}
